export const ShapeBubbles = [
  {
    title: 'Collaborate, co-create, and localize so the experience can thrive in any market',
    description: 'Collect requirements and needs.',
    backgroundColor: '#FAF7EA',
  },
  {
    title: 'Map network ideas and audit assets across capabilities',
    description: 'See if there are any gaps, and see how to best maximize content usage.',
    backgroundColor: '#FAF7EA',
  },
  {
    title: 'Amplify ideas and build adaptation needs assets',
    description: 'Connect with your Studio X and partners and check with legal/ SRA about any potential risks.',
    backgroundColor: '#FAF7EA',
  },
  {
    title: 'Finalize and build market activation plans',
    description:
      'Finalize and sign off on integrated media and asset plan. Prepare any pre-launch testing or experiments to run throughout the plan to get early insights.',
    backgroundColor: '#FAF7EA',
  },
]

export const ShapeKeyInputs = [
  { text: 'Roadmap, market profile, market requirements' },
  { text: 'Local context, data signals, & insights audience insights' },
  { text: 'Planned media investment' },
  { text: 'E2E/ audience & media guidance' },
  { text: 'UMM findings' },
]
export const ShapeKeyOutputs = [
  { text: 'Market activation plans' },
  {
    text: 'Reflections and improvements on ways of working',
    link: 'https://app.mural.co/t/marketing6265/m/marketing6265/1747976237864/f1cf546811959a5c0c18fc38ec66fbdef1cdaf45',
  },
]

export const ShapeCards = [
  {
    title: 'The power of Assemble',
    description:
      'The stronger your Assemble was, the better your Shape output will be, as it will be clear which markets are scaled, what resources are needed, etc. ',
  },
  {
    title: 'Jump straight to Market Shape',
    description: 'Focus on shaping plans for your markets with your Studio X teams. Avoid building out OU toolkits. ',
  },
  {
    title: 'Adapt participation to your needs',
    description:
      'For multimarket OUs, it might make sense to only invite lead markets and/or cluster markets based on similar needs and opportunities. ',
  },
  {
    title: 'Start with data',
    description:
      'Place audience planning at the heart to identify gaps in missing creative or audience segments. Leverage 1st, 2nd, 3rd party data.',
  },
  {
    title: 'Fix & Flex',
    description:
      'Markets don’t recreate everything from scratch, but they do fill out any gap in the central plan to ensure it really caters to them. ',
  },
  {
    title: 'Fewer, bigger, better',
    description: 'Go big on 4-5 key touchpoints that will truly move the needle, instead of trying to do everything.',
  },
  {
    title: 'Collapsed decision making',
    description:
      'Recommended decision making sits with Category & FLM (but should be aligned to your OU decision matrix.)',
  },
  {
    title: 'Creativity meets reality',
    description: 'Understand investment constraints and market reality to minimize waste and duplication.',
  },
]
